import { SimpleError } from '@common/errors';
import { PatchableArray, PatchableArrayDecoder } from './PatchableArray.js';
import StringOrNumberDecoder from './StringOrNumberDecoder.js';
import { isPatchableArray } from '../classes/Patchable.js';
import { addIndexField, ObjectData } from '../classes/ObjectData.js';
export class ArrayDecoder {
    decoder;
    constructor(decoder) {
        this.decoder = decoder;
    }
    decodeField(value, context, currentField) {
        if (Array.isArray(value)) {
            if (this.decoder.decodeField) {
                const arr = new Array(value.length);
                for (let i = 0; i < arr.length; i++) {
                    arr[i] = this.decoder.decodeField(value[i], context, addIndexField(currentField, i));
                }
                return arr;
            }
            else {
                const arr = new Array(value.length);
                for (let i = 0; i < arr.length; i++) {
                    arr[i] = new ObjectData(value[i], context, addIndexField(currentField, i)).decode(this.decoder);
                }
                return arr;
            }
        }
        throw new SimpleError({
            code: 'invalid_field',
            message: `Expected an array at ${currentField}`,
            field: currentField,
        });
    }
    decode(data) {
        const value = data.value;
        if (Array.isArray(value)) {
            if (this.decoder.decodeField) {
                const arr = new Array(value.length);
                for (let i = 0; i < arr.length; i++) {
                    arr[i] = this.decoder.decodeField(value[i], data.context, data.addToCurrentField(i));
                }
                return arr;
            }
            else {
                const arr = new Array(value.length);
                for (let i = 0; i < arr.length; i++) {
                    arr[i] = data.clone({
                        data: value[i],
                        context: data.context,
                        field: data.addToCurrentField(i),
                    }).decode(this.decoder);
                }
                return arr;
            }
        }
        throw new SimpleError({
            code: 'invalid_field',
            message: `Expected an array at ${data.currentField}`,
            field: data.currentField,
        });
    }
    patchType() {
        const elementDecoder = this.decoder;
        if (elementDecoder.patchType) {
            const patchDecoder = elementDecoder.patchType();
            // Check if we have a method called "getIdentifier"
            let idFieldType;
            if (elementDecoder.patchIdentifier) {
                // Custom identifier (in case no automatic detection is possible)
                idFieldType = elementDecoder.patchIdentifier();
            }
            else {
                if (patchDecoder.prototype.getIdentifier) {
                    // This autoencoder uses the getIdentifier method to define the id
                    idFieldType = StringOrNumberDecoder;
                }
                else {
                    const field = elementDecoder.fields.find(field => field.property == 'id');
                    if (field) {
                        idFieldType = field.decoder;
                    }
                }
            }
            if (idFieldType) {
                return new PatchableArrayDecoder(elementDecoder, patchDecoder, idFieldType);
            }
            else {
                // A non identifiable array -> we expect an optional array instead = default behaviour
                // upgrade / downgrade kan stay the same as default
                // We expect a normal array, of same type
                return this;
            }
        }
        // Upgrade / downgrades cannot work when pathcing, should be placed on instances
        // field.upgrade = this.upgradePatch
        // field.downgrade = this.downgradePatch
        return new PatchableArrayDecoder(elementDecoder, elementDecoder, elementDecoder);
    }
    /**
     * @deprecated
     * use patchType().getDefaultValue instead
     * Patchable values of an array always create a default empty patchable array for convenience
     */
    patchDefaultValue() {
        const elementDecoder = this.decoder;
        if (elementDecoder.patchType) {
            const patchDecoder = elementDecoder.patchType();
            // Check if we have a method called "getIdentifier"
            let idFieldType;
            if (elementDecoder.patchIdentifier) {
                // Custom identifier (in case no automatic detection is possible)
                idFieldType = elementDecoder.patchIdentifier();
            }
            else {
                if (patchDecoder.prototype.getIdentifier) {
                    // This autoencoder uses the getIdentifier method to define the id
                    idFieldType = StringOrNumberDecoder;
                }
                else {
                    const field = elementDecoder.fields.find(field => field.property == 'id');
                    if (field) {
                        idFieldType = field.decoder;
                    }
                }
            }
            if (idFieldType) {
                return new PatchableArray();
            }
            else {
                // A non identifiable array -> we expect an optional array instead = default behaviour
                // upgrade / downgrade kan stay the same as default
                // We expect a normal array, of same type
                return undefined;
            }
        }
        return new PatchableArray();
    }
    isPatchDefaultValue(value) {
        return isPatchableArray(value) && value.changes.length === 0;
    }
    isDefaultValue(value) {
        return Array.isArray(value) && value.length === 0;
    }
    getDefaultValue() {
        return [];
    }
}
//# sourceMappingURL=ArrayDecoder.js.map